export default "__VITE_ASSET__i3Ke4yS9__"